// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-k_gV","advertDetailService__price":"c-k_gW"};